export const signDocsState = {
  docs: []
}
